

























































import { Component,	Vue } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from './mixins'
import { Languages } from '@/enums'

import AppStart from './views/Start.vue'
import AppInfo from './components/AppInfo.vue'

@Component({
	components: {
		AppStart,
		AppInfo
	}
})
export default class VOGcheck extends GlobalMixins {
	infoOpen: boolean = false
	previousButtonType: 'previous' | 'start' = 'previous'
	nextButton: 'next' | 'skip' | false | {min: number | false, max: number | false, label: string} = false
	openScreen: string | false = false
	Languages = Languages
	
	get nextButtonClasses(): string {
		if (this.nextButton) {
			if (this.nextButton === 'skip') {
				return 'button--skip button--purple'
			} else {
				return 'button--next button--purple'
			}
		} else {
			return ''
		}
	}
	get nextButtonLabel(): string | false {
		if (this.nextButton !== false && this.nextButton !== 'skip' && this.nextButton !== 'next') {
			if (this.nextButton.min && this.nextButton.max) {
				return this.nextButton.label
			} else {
				return this.nextButton.label
			}
		}

		return false
	}

	clickPreviousButton(): void {
		switch(this.$route.name) {
			case 'home':
				break
			case 'select-age':
			case 'select-age-'+this.language:
				this.$router.push({ name: 'home' })
				break
			case 'select-branch':
			case 'select-branch-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'select-age' : 'select-age-'+this.language })
				break
			case 'criminal-record':
			case 'criminal-record-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'select-branch' : 'select-branch-'+this.language })
				break
			case 'select-crime':
			case 'select-crime-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'criminal-record' : 'criminal-record-'+this.language })
				break
			case 'select-punishment':
			case 'select-punishment-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'select-crime' : 'select-crime-'+this.language })
				break
			case 'crime-when':
			case 'crime-when-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'select-punishment' : 'select-punishment-'+this.language })
				break
			case 'punishment-when':
			case 'punishment-when-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'select-punishment' : 'select-punishment-'+this.language })
				break
			case 'punishment-length':
			case 'punishment-length-'+this.language:
				this.$router.push({ name: this.language === Languages.NL ? 'punishment-when' : 'punishment-when-'+this.language })
				break
			case 'results':
			case 'results-'+this.language:
				if (this.$store.getters.user.criminalRecord === 'no') {
					this.$router.push({ name: this.language == Languages.NL ? 'criminal-record' : 'criminal-record-'+this.language })
				} else if (this.$store.getters.user.punishmentWhen === 'skipped') {
					this.$router.push({ name: this.language === Languages.NL ? 'crime-when' : 'crime-when-'+this.language })
				} else {
					this.$router.push({ name: this.language === Languages.NL ? 'punishment-length' : 'punishment-length-'+this.language })
				}
				break
			default: 
				this.$router.push({ name: 'home' })
				break
		}
	}
	clickNextButton(): void {
		if (this.nextButton !== false &&  this.nextButton !== 'skip') {
			bus.$emit('goToNextScreen')
		} else if (this.nextButton === 'skip') {
			bus.$emit('skipQuestion')
		}
	}
	moveToHome(): void {
		this.$router.push({ name: 'home' })

		setTimeout(() => {
			this.$store.dispatch('resetUser')
		}, 400)
	}

	reloadPage(): void {
		this.$router.push(location.host)
		location.reload()
	}

	setLanguage(language: Languages): void {
		const oldRouteName = this.trimmedRouteName;
		this.$store.dispatch('setLanguage', language)
		this.$router.push({ name: language === Languages.NL ? oldRouteName : oldRouteName +'-'+language })
	}

	created() {
		_paq.push(['trackEvent', 'systeemBerichten', 'applicatieGeladen'])
	}

	mounted() {
		bus.$on('closeInfo', () => {
			this.infoOpen = false

			setTimeout(() => {
				this.openScreen = false
			}, 400)
		})
		bus.$on('toggleInfo', (openScreen?: string) => {
			if (openScreen && this.openScreen !== false && this.openScreen !== openScreen) {
				this.infoOpen = false

				setTimeout(() => {
					this.openScreen = openScreen
					this.infoOpen = true
				}, 400)
			} else {
				setTimeout(() => {
					if (openScreen && openScreen !== this.openScreen) {
						this.openScreen = openScreen
					} else {
						this.openScreen = false
					}
				}, this.infoOpen ? 400 : 0)
				
				this.infoOpen = !this.infoOpen
			}
		})
		bus.$on('setPreviousButton', (buttonType: 'previous' | 'start') => {
			this.previousButtonType = buttonType
		})
		bus.$on('setNextButton', (buttonType: 'next' | 'skip' | false | {min: number | false, max: number | false, label: string}) => {
			this.nextButton = buttonType
		})
	}
}
